import React, {useEffect} from "react";
import classNames from "classnames";
import {DispatchContext, StateContext} from "../../containers/sidebarContext";
import blackBackground from "../../assets/pictures/old-black-background.jpg";
import {NavLink} from "react-router-dom";
import {Fragment} from "react";

import {FaBeer, FaHome, FaCoffee, FaWineGlassAlt, FaGlassWhiskey, FaWineBottle} from 'react-icons/fa';
import {GiGlassShot} from "react-icons/gi";
import {IoMdCall} from "react-icons/io"
import {useTranslation} from "react-i18next";

const Sidebar = () => {
    const state = React.useContext(StateContext);
    const dispatch = React.useContext(DispatchContext);
    const {isSidebarOpen, activeItem} = state;
    const { t } = useTranslation();
    const sidebarItems = [
        {id: 1, title: t("sidebar:caffe"), link: "/kaffee", icon: <FaCoffee/>},
        {id: 2, title: t("sidebar:refreshing_drinks"), link: "/erfrischendeGetranke", icon: <GiGlassShot/>},
        {id: 3, title: t("sidebar:beer"), link: "/bier", icon: <FaBeer/>},
        {id: 4, title: t("sidebar:wine"), link: "/wine", icon: <FaWineGlassAlt/>},
        {id: 5, title: t("sidebar:alcohol"), link: "/alkohol", icon: <FaGlassWhiskey/>},
        {id: 6, title: t("sidebar:bottle_price"), link: "/flaschenpreise", icon: <FaWineBottle/>},
        {id: 7, title: t("sidebar:give_us_a_call"), icon: <IoMdCall/>, href: "tel:+49 174 3774389"},
    ];

    function toggleSidebar(item){
        if(item === activeItem){
            dispatch({type: "toggleSidebar", payload: false});
        }
        dispatch({ type: "activeSidebarItem", payload: item })
        window.scrollTo(0, 0);
    }

    useEffect(() => {
        if (activeItem !== "Rufen Sie uns an" && activeItem !=="home") {
            dispatch({type: "toggleSidebar", payload: false});
            dispatch({type: "activeSidebarItem", payload: activeItem});
            window.scrollTo(0, 0);
        }
    }, [activeItem]);

    const sidebarStatus = classNames({
        active: isSidebarOpen,
    });

    const wrapper = classNames({
        wrapper: true,
        "sidebar-background": true,
        "slide-right": true
    });

    return (
        <Fragment>
            {!isSidebarOpen && (
                <div
                    style={{
                        backgroundImage: `url(${blackBackground})`,
                        backgroundSize: "cover",
                    }}
                    className={wrapper}
                >
                    <nav id="sidebar" className={sidebarStatus}>
                        <ul className="list-unstyled components">
                            <li
                                key="home"
                                className={activeItem === "Start Page" ? "active sidebar-item" : "sidebar-item"}
                                onClick={() => toggleSidebar("Start Page")}
                            >

                                <NavLink
                                    to="/home"
                                    data-toggle="collapse"
                                    aria-expanded="false"
                                ><a className="icon-position" aria-hidden="true"><FaHome/></a>
                                    {t("sidebar:homepage")}
                                </NavLink>
                            </li>
                            {sidebarItems.map((item) => (
                                <li
                                    key={item.id}
                                    className={activeItem === item.title ? "active sidebar-item" : "sidebar-item"}
                                    onClick={() => toggleSidebar(item.title)}
                                >

                                    {item.link ?
                                        <NavLink
                                            to={item.link}
                                            data-toggle="collapse"
                                            aria-expanded="false"
                                        ><a href={item.href && item.href} className="icon-position"
                                            aria-hidden="true">{item.icon}</a>
                                            {item.title}
                                        </NavLink> :
                                        <>
                                            <a href={item.href && item.href} className="icon-position"
                                               aria-hidden="true">{item.icon}</a>
                                        <a href={item.href && item.href}>{item.title}</a>
                                        </>
                                    }
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            )}
        </Fragment>
    );
};
export default Sidebar;
